import { Card } from "../Card";

export function LoggedOutCard({ children }: {
    children: React.ReactNode;
}) {
    return (

        <div className="w-full max-w-md bg-background overflow-x-hidden" >
            <Card className='bg-surface text-onsurface'>
                {children}
            </Card>
        </div>
    );
}
